import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-input-errors',
  templateUrl: './input-errors.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslatePipe,
  ],
})
export class InputErrorsComponent {
  public readonly errorsForField = input<any>();
  public readonly translationKey = input<string>(undefined!); // e.g. 'campaigns.form.errors'
  public readonly additionalErrorsMapping = input<any>(); // e.g { 'after': 'some.key' }
  public readonly areTranslationKeys = input(true);
  private DEFAULT_TRANSLATION_KEY = 'errors.messages';

  public errorTranslationKey(error: string): string {

    const additionalErrorsMapping = this.additionalErrorsMapping();
    // eslint-disable-next-line no-prototype-builtins
    if (additionalErrorsMapping?.hasOwnProperty(error)) {
      return additionalErrorsMapping[error];
    }
    if (this.translationKey != null) { return `${this.translationKey()}.${error}`; }

    return `${this.DEFAULT_TRANSLATION_KEY}.${error}`;
  }
}
